module.exports = __webpack_public_path__ + "static/media/seek-for-help.fe722a2c.png";